<template lang="pug">
  transition(name='modal')
    .modal-mask(@click.self="triggerCloseModal()")
      .modal-wrapper(@click.self="triggerCloseModal()")
        .modal-container.modal-trocar-responsavel-lote
          .modal-header
            p.title Vincular Responsável em Lote
            el-button.btn#btn(
              type="text",
              @click="triggerCloseModal()",
              size="mini"
            )
              i.material-icons.icon close
          .modal-body()
            div
              el-row.row
                p Processos selecionados: {{ idsProcessos.length }}
              el-row.row
                p Selecione abaixo o nome do responsável a ser vinculado nos processos:
              el-row.row
                el-select.full-width(
                  v-model='usuarioVinculado',
                  placeholder='Selecione o responsável',
                  no-match-text="Usuário não encontrado",
                  no-data-text="Nenhum usuário disponível",
                  filterable,
                  clearable,
                  :id="'id-selecionar-responsavel-lote'"
                )
                  el-option.listResponsavel(
                    v-for='usuario in usuariosDisponiveis',
                    :key='usuario.id',
                    :label='usuario.nomeCargo',
                    :value='usuario.id'
                  )
          .modal-footer
            slot(name="footer")
              el-button(@click="trocar", :disabled="!usuarioVinculado || usuariosDisponiveis.length === 0") Confirmar

</template>

<script>
import { mapActions } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
export default {
  props: {
    idsProcessos: {
      type: Array,
      required: true
    },
    caixa: {
      type: String,
      required: true
    }
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      colorCopy: '#666666',
      hoverColor: '#079D67',
      usuarioVinculado: null,
      usuariosDisponiveis: []
    }
  },

  async created () {
    const usuarios = await this.getUsuariosPorSetor(this.caixa)
    this.usuariosDisponiveis = usuarios || []
  },

  computed: {

  },

  methods: {
    ...mapActions({
      getUsuariosPorSetor: 'dados/getUsuariosPorSetor',
      trocarResponsavelLote: 'dados/trocarResponsavelLote'
    }),

    trocar () {
      if (this.usuarioVinculado && this.idsProcessos.length > 0) {
        const processo = {
          idsProcesso: this.idsProcessos,
          idUsuario: this.usuarioVinculado
        }
        this.trocarResponsavelLote(processo).then((response) => {
          const processosTrocados = response?.processosTrocados?.length || 0
          const processosComErro = response?.processosComErro?.length || 0
          const total = processosTrocados + processosComErro
          let mensagem = ''

          if (processosComErro === 0) {
            mensagem = `Os processos selecionados foram vinculados com sucesso.`
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, mensagem)
          } else if (processosTrocados === 0) {
            mensagem = `Nenhum processo foi vinculado.`
            this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR, mensagem)
          } else {
            mensagem = `${processosComErro} de ${total} processo${total !== 1 ? 's' : ''} apresentaram erro na vinculação.`
            this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, mensagem)
          }

          this.$emit('refresh')
          this.triggerCloseModal()
        }).catch(() => {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_ERROR,
            'Não foi possível trocar os responsáveis'
          )
        })
      } else {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
          'Escolha um responsável!'
        )
      }
    },

    triggerCloseModal () {
      this.$emit('closeModal')
    }

  }
}
</script>

<style scoped lang="scss">
.modal-trocar-responsavel-lote {
  height: 20em;
  width: 40em;
}

.modal-mask {
  position: fixed;
  z-index: 8;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.full-width {
  width: 95%;
}

.modal-wrapper {
  margin-top: 8vh;
}

.modal-container {
  min-height: 200px;
  max-height: 84vh;
  margin: 0px auto;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #009f60;
  border-radius: 10px 10px 0 0;
  height: 55px;
}

.modal-body {
  padding: 10px;
  margin: 10px 30px;
  overflow-y: auto;
  max-height: 76vh;
  flex-grow: 1;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  background-color: white;
  padding: 10px;
  border-radius: 0px 0px 10px 10px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.title {
  margin: 0;
  font-size: 18px;
  color: white !important;
  font-weight: bold;
  padding: 0 10px;
  margin-bottom: 0px !important;
}

.btn {
  padding-right: 20px;
  color: white;

  .icon {
    font-size: 18px;
  }
}

@media (max-width: 780px) {
  .modal-trocar-responsavel-lote {
    width: 23em;
  }

  .listResponsavel {
    left: 115px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/ModalTrocarResponsavelLote.vue